/* global grecaptcha */

export const getCaptchaToken = action =>
  new Promise((resolve, reject) => {
    grecaptcha.enterprise.ready(() =>
      grecaptcha.enterprise
        .execute(process.env.RAZZLE_GOOGLE_RECAPTCHA_SITE_KEY, {
          action,
        })
        .then(token => resolve(token))
        .catch(err => reject(err))
    )
  })
